<template lang="pug">

    tr

        //- Name
        td {{ supplierModel.name }}

        //- PLZ, Ort
        td {{ zipAndCity }}

        //- Action
        td.right.aligned

            //- Job hinzufuegen
            button.ui.mini.icon.button(v-tooltip='"Hinzufügen"' v-on:click='click()')
                i.plus.icon

</template>

<script>
    import * as R from 'ramda'

    //noinspection JSUnusedGlobalSymbols
    export default {

        computed: {

            zipAndCity() {
                return R.ifElse(
                    // Wenn Adress Objekt ist
                    R.is(Object),

                    // String aus PLZ und Stadt zusammensetzen
                    addressModel => `${addressModel.zip} ${addressModel.city}`,

                    // Ansnsten Standardstring zurueckgebe
                    R.always('-')

                )(this.addressModel)
            }

        },

        data() {
            return {
                selectedSuppliers: []
            }
        },

        methods: {

            click() {
                this.$emit('input', this.supplierModel)
            }

        },

        props: {

            addressModel: {
                type: Object

            },

            supplierModel: {
                type: Object,
                required: true
            }

        }

    }

</script>
